<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.payment_terms.form.payment_term')"
            :is-required="true"
            :hint="__('settings.payment_terms.form.payment_term_hint')"
        >
            <DInput
                id="paymentTerm"
                v-model="form.payment_term"
                :placeholder="__('settings.payment_terms.form.payment_term')"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('payment_term')"
                :invalid-feedback="errors.payment_term"
                maxlength="45"
            />
        </DFormRow>
        <DFormControls
            :cancel-route="$route('settings.payment-terms.index')"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'

const props = defineProps({
    paymentTerm: {
        type: Object,
        default: () => { return {} }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const form = useForm({
    payment_term: props.paymentTerm?.payment_term ?? null
})

const emit = defineEmits(['form-submitted'])
function submitForm () {
    emit('form-submitted', form)
}

</script>
